import { faCheck, faTimes } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import * as React from "react"
import styled from "styled-components"
import Layout from "../components/layout"
import SEO from "../components/seo"
import ContactBanner from "../components/ContactBanner"

const StyledPricingTable = styled.div`
  padding: 0 1rem;
  margin-bottom: 4rem;
  .table-wrapper {
    border-radius: 5px;
    overflow-x: scroll;
    box-shadow: 0px 0px 2px 0px rgba(0, 0, 0, 0.2);
    margin-bottom: 4rem;
  }
  table {
    background: rgba(14, 30, 37, 0.02);
    box-shadow: none;
    margin: 0;
    border-collapse: collapse;
    display: table;
    max-width: 100%;
    overflow-x: auto;
    table-layout: fixed;
    width: 100%;
    min-width: 900px;
    text-align: left;
    td,
    th {
      font-weight: 600;
      padding: 1.5rem;
      text-align: center;
    }
    th {
      &[colspan] {
        background-color: #e3ebed;
        font-weight: 600;
      }
      :first-child {
        text-align: left;
      }
    }
    tbody {
      td:nth-child(even) {
        background: rgba(14, 30, 37, 0.02);
      }
      tr:nth-child(odd) {
        background: rgba(14, 30, 37, 0.02);
      }
      th {
        font-weight: 400;
      }
    }
    .fa-check {
      color: ${({ theme }) => theme.colors.green};
    }
    .fa-times {
      color: ${({ theme }) => theme.colors.obsidian};
    }
    .plan {
      text-transform: uppercase;
      font-weight: 600;
    }
  }
`

export default () => (
  <Layout>
    <SEO title="Pricing" />
    <div className="container">
      <div className="heading">
        <h1>Pricing</h1>
        <h4 className="secondary">
          From a small showroom to a multi-franchise enterprise, we have
          something for everyone.
        </h4>
      </div>
      <StyledPricingTable>
        <div className="table-wrapper">
          <table>
            <thead>
              <tr>
                <th scope="col" className="visibilityHidden"></th>
                <th scope="col">
                  <span className="plan">Standard</span>
                </th>
                <th scope="col">
                  <span className="plan">Enterprise</span>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <th colSpan={3} scope="colgroup">
                  Pricing
                </th>
              </tr>

              <tr>
                <th scope="row">Per month</th>
                <td headers="price-standard pricing-per-month">£29</td>
                <td headers="price-enterprise pricing-per-month">Custom</td>
              </tr>
            </tbody>
            <tbody>
              <tr>
                <th colSpan={3} scope="colgroup">
                  Features
                </th>
              </tr>
              <tr>
                <th scope="row">Online Deposits</th>
                <td headers="features-team-standard">
                  <FontAwesomeIcon icon={faCheck} />
                </td>
                <td headers="features-enterprise">
                  <FontAwesomeIcon icon={faCheck} />
                </td>
              </tr>
              <tr>
                <th scope="row">Messenger</th>
                <td headers="features-team-standard">
                  <FontAwesomeIcon icon={faCheck} />
                </td>
                <td headers="features-enterprise">
                  <FontAwesomeIcon icon={faCheck} />
                </td>
              </tr>
              <tr>
                <th scope="row">Social Proof</th>
                <td headers="features-team-standard">
                  <FontAwesomeIcon icon={faCheck} />
                </td>
                <td headers="features-enterprise">
                  <FontAwesomeIcon icon={faCheck} />
                </td>
              </tr>
              {/* <tr>
                <th scope="row">Weather Sensitive Prompts</th>
                <td headers="features-team-standard">
                  <FontAwesomeIcon icon={faCheck} />
                </td>
                <td headers="features-enterprise">
                  <FontAwesomeIcon icon={faCheck} />
                </td>
              </tr> */}
              <tr>
                <th scope="row">Exit-Intent Popups</th>
                <td headers="features-team-standard">
                  <FontAwesomeIcon icon={faCheck} />
                </td>
                <td headers="features-enterprise">
                  <FontAwesomeIcon icon={faCheck} />
                </td>
              </tr>
              <tr>
                <th scope="row">Custom Features</th>
                <td headers="features-team-standard">
                  <FontAwesomeIcon icon={faTimes} />
                </td>
                <td headers="features-enterprise">
                  <FontAwesomeIcon icon={faCheck} />
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </StyledPricingTable>
    </div>
    <ContactBanner />
  </Layout>
)
